import { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import store from "../../store";
import ss from "./Alert.module.css";

// type: alert, confirm
export const AlertComponent = () => {
  const { visible, type, title, message, hint, onClose, onConfirm } =
    useSelector((state) => state.alert);
  const [isClosing, setIsClosing] = useState(false);

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose?.();
      setIsClosing(false);
      store.dispatch.alert.hide();
    }, 600);
  };

  if (!visible) return <></>;

  return (
    <div
      className={classNames(ss.mask, isClosing && ss.fadeOut)}
      //   onClick={closeModal}
    >
      <div className={classNames(ss.box, isClosing && ss.zoomOut)}>
        <div className={ss.title}>{title}</div>
        <div className={ss.content}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
          {hint && <div className={ss.hint}>{hint}</div>}
        </div>

        <div className={ss.btns}>
          {type === "confirm" && (
            <div
              className={ss.btn}
              onClick={() => {
                onClose?.();
                closeModal();
              }}
            >
              关闭
            </div>
          )}
          <div
            className={ss.btn}
            onClick={() => {
              onConfirm?.();
              closeModal();
            }}
          >
            确认
          </div>
        </div>
      </div>
    </div>
  );
};

export default class Alert {
  static show(payload) {
    store.dispatch.alert.show(payload);
  }
  static hide() {
    store.dispatch.alert.hide();
  }
}
